import './lib/turbo';

// Global libraries (order matters - lib/ files assign to window)
import './lib/jquery';
import './lib/bootstrap';
import './lib/rails_ujs';
import './lib/toastr';
import './lib/chartkick';

// jQuery plugins (must load after jQuery is on window)
import 'jquery-countdown';
import './lib/select2';
import 'slick-carousel/slick/slick.min';

// External dependencies
import 'intl-tel-input/build/js/intlTelInput-jquery.min';
import './vendor/capsens_suitability_questionnaire/application';
import '@googlemaps/markerclusterer';

// Helpers (assigns Helpers to window)
import './helpers';

// ActionCable channels
import './cable';

// Platform JS code
import './address_autocomplete';
import './document_name';
import './drop_container';
import './copy_to_clipboard';
import './hide_show_password';
import './mobile_profile_nav';
import './pagy/pagy_config';
import './projects/countdown';
import './responsive_navbar';
import './select2_init';
import './subscription_expiration';
import './users/multiple_choice_upload';
import './users/show_file_input';
import './users/replace_file_input';
import './users/renewal_membership';
import './memberships/store_scrollspy';
import './map';
import './prevent_scroll_on_number_inputs';
import './analytics';
import './subscribe_modal';
import './subscription_form_verification';

// Stimulus controllers
import './controllers/index';

// Inline code from original application.js
$(document).ready(function () {
  $('.auto-input').on('change', function () {
    const form = $(this).parents('form')[0];
    Rails.fire(form, 'submit');
  });

  const tooltipTriggerList = document.querySelectorAll(
    '[data-bs-toggle="tooltip"]'
  );
  [...tooltipTriggerList].map(
    (tooltipTriggerEl) => new bootstrap.Tooltip(tooltipTriggerEl)
  );

  $('body').on('change', '.file-input', function () {
    if ($(this)[0].files[0] !== undefined) {
      $(this).parent().find('.label-wording').html($(this)[0].files[0].name);
    }
  });
});
